import loadItemReadingPane from './loadItemReadingPane';
import setItemPrintPaneViewState from './setItemPrintPaneViewState';
import datapoints from '../datapoints';
import { ClientItemId } from 'owa-client-ids';
import { ActionSource, createLegacyActionWithDatapoint } from 'owa-analytics-actions';

export default createLegacyActionWithDatapoint(
    'print',
    datapoints.PrintItem
)(function print(itemId: ClientItemId, actionSource: ActionSource): Promise<void> {
    const itemIdToPrint = itemId;
    if (itemIdToPrint) {
        return loadItemReadingPane(
            itemIdToPrint,
            null /* instrumentationContext */,
            setItemPrintPaneViewState,
            true /* isPrint */
        );
    } else {
        return Promise.resolve();
    }
});
